import React from 'react';
import socialMediaLinks from '../data/socialMediaLinks';
import { LandingVariant } from '../utils/landingVariant';

interface SocialIconsProps {
  variant?: LandingVariant;
  layout?: 'icons' | 'buttons';
}

const SocialIcons: React.FC<SocialIconsProps> = ({ variant, layout = 'icons' }) => {
  const handleButtonClick = (name: string, type: string) => {
    const eventName = type === 'streaming' ? 'StreamingClick' : type === 'social' ? 'SocialClick' : null;
    if (!eventName) return;

    const params = variant ? { content_name: name, variant } : { content_name: name };
    fbq('trackCustom', eventName, params);
    gtag('event', eventName === 'StreamingClick' ? 'streaming_click' : 'social_click', params);
  };

  const renderLinks = (type: string) =>
    socialMediaLinks
      .filter((link) => link.type === type)
      .map((link, index) => (
        <a
          href={link.url}
          target='_blank'
          rel='noopener noreferrer'
          key={index}
          title={link.name}
          className={layout === 'buttons' ? 'link-button' : undefined}
          onClick={() => handleButtonClick(link.name, link.type)}>
          <link.icon className='icon' />
          {layout === 'buttons' && <span className='link-label'>{link.name}</span>}
        </a>
      ));

  const groupClassName = layout === 'buttons' ? 'link-list' : 'social-icons';

  return (
    <div>
      <h1>LISTEN</h1>
      <div className={groupClassName}>{renderLinks('streaming')}</div>
      <h1>CONNECT</h1>
      <div className={groupClassName}>{renderLinks('social')}</div>
    </div>
  );
};

export default SocialIcons;
